module.exports = __webpack_public_path__ + "img/logo.2bd803d7.svg";